<template>
  <div class="search-box">
    <div class="input-group input-group-outline mb-3 has-validation"
      :class="{ 'focused is-focused': focused, 'is-filled': searchQuery || selectedItem, 'my-input-disabled': isBlocked === true }">
      <label class="form-label">{{ label }}</label>
      <i class="bx bx-purchase-tag search-input-icon"></i>
      <div v-if="selectedItem" class="badge-container form-control">
        <template v-if="isBlocked === true">
          <span class="my-badge color-box" :class="tagColor">
            {{ selectedItem.name }}
          </span>
        </template>
        <template v-else>
          <span class="my-badge color-box" :class="tagColor" @click="removeSelectedItem">
            {{ selectedItem.name }}
          </span>
        </template>
      </div>

      <input v-else type="text" class="form-control" @focus="onFocus" @blur="onBlur" @input="filterItems"
        v-model="searchQuery" @keyup.enter="addNewItem" ref="searchInput" :disabled="isBlocked === true" />
      <ul v-if="showSuggestions" class="list-group">
        <li class="list-group-item" v-for="item in filteredItems" :key="item.id" @click="setItem(item);">{{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    id: { type: [String, Number], default: null },
    label: { type: String, required: false, default: "" },
    items: { type: [String, Array], required: true, default: () => [] },
    defaultValue: { type: [String, Number], default: null },
    tagCss: { type: [String, Number], default: "1" },
    addNewValue: { type: Number, default: 0 },
    userAdmin: { type: [Number, String], required: false }
  },
  data() {
    return {
      focused: false,
      searchQuery: "",
      filteredItems: [],
      selectedItem: null,
      tagColor: null
    };
  },
  computed: {
    isBlocked() {
      if (this.userAdmin != null && this.userAdmin != 1) {
        return true;
      }
      return false;
    },
    showAddButton() {
      return (
        this.searchQuery && !this.filteredItems.length && !this.selectedItem
      );
    },
    showSuggestions() {
      return (
        this.focused && !this.selectedItem && this.filteredItems.length > 0
      );
    }
  },
  mounted() {
    this.filteredItems = this.items;
    if (this.defaultValue) {

      const valorRealIndex = this.items.findIndex(
        item => item.id === parseInt(this.defaultValue)
      );
      const valorReal = valorRealIndex !== -1 ? this.items[valorRealIndex] : null;

      this.tagColor = `tag-${valorRealIndex}`;
      this.selectedItem = valorReal ? valorReal : null;

    }

  },
  methods: {
    ...mapActions([
      "showMessage"
    ]),
    filterItems() {
      const query = this.searchQuery.toLowerCase();
      this.filteredItems = this.items.filter(item =>
        item.name.toLowerCase().includes(query)
      );
    },
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      setTimeout(() => {
        this.focused = false;
      }, 150); // Small delay to allow click events to register on items before blur
    },
    setItem(item) {
      console.log('emmit value!')
      this.selectedItem = item;
      this.$emit("input", item, this.id);
      this.searchQuery = "";
      this.focused = false;

      const valorRealIndex = this.items.findIndex(
        find => find.id === parseInt(item.id)
      );

      this.tagColor = `tag-${valorRealIndex}`;
    },
    createNewId() {
      let newId = 0;
      this.items.forEach(el => {
        if (el.id > newId) {
          newId = el.id
        }
      });
      return newId + 1;
    },
    async publicateNewPropertieValue(newVal) {
      let realParans = this.id.split("-");
      console.log('SET item value', realParans[0])
      let completeData = [...this.items, newVal];
      const data = {
        'modelo': realParans[1],
        'name': this.label,
        'values': JSON.stringify(completeData)
      };

      const response = await this.$AppCallApi("put", `f-propertie-value/${realParans[0]}`, data);
      if (response.status === 200) {
        //this.$emit("input", newId, this.id)
        this.showMessage({
          title: "Atenção: um novo valor foi adicionado ao camp",
          text: [],
          css: "bg-info"
        });
      }
      else {
        this.showMessage({
          title: "Desculpe um erro aconteceu!",
          css: "bg-danger"
        });
      }
    },
    addNewItem() {
      if (this.addNewValue === 0) {
        this.showMessage({
          title: "Atenção: nível administrativo insuficiênte:",
          text: ["Por favor, use uma opção pré-definida ou entre em contato com um administrador."],
          css: "bg-info"
        });
        this.searchQuery = "";
        return;
      }
      if ((!this.id || this.id.match(/-/g) || []).length != 2) {
        this.showMessage({
          title: "Você não pode fazer isso.",
          css: "bg-danger"
        });
        return;
      }
      /* modificando o novo item */
      if (!this.showAddButton) return;
      let newId = this.createNewId();
      const newItem = {
        id: newId,
        name: this.searchQuery,
        status: true
      };
      this.publicateNewPropertieValue(newItem);
      this.items.push(newItem);
      this.setItem(newItem);
    },
    removeSelectedItem() {
      this.selectedItem = null;
      this.$emit("input", null, this.id);
      this.filteredItems = this.items;
    }
  }
};
</script>

<style scoped>
.search-box {
  position: relative;
  float: left;
  width: 100%;
}

.badge-container {
  display: inline-block;
  padding-bottom: 0 !important;
}

.list-group {
  position: absolute;
  left: 0;
  right: 0;
  top: 40px;
  height: auto;
  max-height: 300px;
  overflow: auto;
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  border: 2px solid #ddd !important;
  background: none;
  border-top: none;
  list-style: none;
  z-index: 9999;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  height: auto;
  background: #f8f9fa;
  border-top: 1px solid #fff;
  color: #8687a4;
}

.list-group-item:hover {
  background: white !important;
  color: #3b5de7 !important;
  cursor: pointer;
}

.search-input-icon {
  position: absolute;
  float: left;
  left: 12px;
  top: 16px;
  z-index: 3;
  font-size: 16px;
  color: #ccc
}

.form-control {
  padding-left: 40px;
}

.my-badge {
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  margin-top: 5px;
  display: inline-block;
  padding: 4px 6px;
  line-height: 1;
  max-width: 100%;
  text-wrap: nowrap;
  overflow: hidden;
}

.clear-button {
  padding: 0px;
  font-size: 14px;
  line-height: 14px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
}
</style>